<template>
	<modal
		class="store-status-modal"
		size="medium"
		@close="close"
	>
		<template slot="header">
			<h3>Store Status</h3>
		</template>
		<template slot="body">
			<p class="text-center">
				Are you sure want to
				<span class="text-bold" :class="{
					'text-danger': storeStatusState === 'close',
					'text-success': storeStatusState === 'open',
				}">
					{{ storeStatusState }}
				</span>
				<span class="text-bold">
					{{ isBulkUpdateStoreStatus ? ` ${selectedItemsLength} ` : ` ${storeName} ` }}
				</span>
				store<span v-if="isBulkUpdateStoreStatus">s</span>?
			</p>
		</template>
		<template slot="footer">
			<!-- Close -->
			<button type="button" class="btn btn-light" @click="close">
				<span>{{ $t('Close') }}</span>
			</button>
			<!-- Update -->
			<button
				class="btn btn-primary"
				:class="{ 'is-loading': isUpdatingStoreStatus }"
				@click="update"
			>
				<span>{{ $t('Update') }}</span>
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
	name: 'ModalUpdateStoreStatus',
	components: {
		Modal,
	},
	props: {
		storeStatusState: {
			type: String,
			default: 'open',
		},
		isBulkUpdateStoreStatus: {
			type: Boolean,
			default: false,
		},
		isUpdatingStoreStatus: {
			type: Boolean,
			default: false,
		},
		selectedItems: {
			default: () => [],
		},
		selectedItem: {
			default: null,
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		update() {
			this.$emit('update');
		},
	},
	computed: {
		storeName() {
			return this.selectedItem?.store?.name ?? '';
		},
		selectedItemsLength() {
			return this.selectedItems?.length ?? 0;
		},
	},
};
</script>
